// Karunna — carrusel propio: flechas + estado + centrado de flechas en la imagen.
class KrnCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-krn-track]');
    this.prevBtn = this.querySelector('[data-krn-prev]');
    this.nextBtn = this.querySelector('[data-krn-next]');
    if (!this.track) return;

    this.reposition = this.reposition.bind(this);

    const step = () => Math.max(this.track.clientWidth * 0.85, 200);
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () =>
        this.track.scrollBy({ left: -step(), behavior: 'smooth' })
      );
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () =>
        this.track.scrollBy({ left: step(), behavior: 'smooth' })
      );
    }
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => { this.update(); this.reposition(); }, { passive: true });

    // Re-evaluar cuando el contenido cambie (recently viewed inyecta por JS).
    this.observer = new MutationObserver(() => {
      this.update();
      this.reposition();
    });
    this.observer.observe(this.track, { childList: true });

    // Centrar las flechas cuando cargue la primera imagen (para modo Auto).
    const firstImg = this.track.querySelector('.krn-card__media img');
    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', this.reposition, { once: true });
    }

    this.reposition();
    this.update();
  }

  // Coloca las flechas a la mitad de la altura de la imagen (no de toda la tarjeta).
  reposition() {
    const media = this.track && this.track.querySelector('.krn-card__media');
    if (!media) return;
    const h = media.getBoundingClientRect().height;
    if (h > 0) {
      this.style.setProperty('--krn-arrow-top', h / 2 + 'px');
    }
  }

  update() {
    const t = this.track;
    if (!t) return;
    const max = t.scrollWidth - t.clientWidth - 2;
    const scrollable = t.scrollWidth > t.clientWidth + 4;
    this.classList.toggle('krn-carousel--static', !scrollable);
    if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
    if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max;
  }
}

if (!customElements.get('krn-carousel')) {
  customElements.define('krn-carousel', KrnCarousel);
}
